module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kg-La.025238f3.png";